// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"576195cb","165":"59b0e10e","219":"bdedb5fc","267":"946ad0f3","453":"b3efecc2","638":"f107ce7b","796":"7fed5707"}[chunkId] + ".chunk.js";
};